/**
 * Electron 이 노출한 원격지원(RustDesk) ID 를 읽는다.
 *
 * 이 값은 부가 정보다. 브라우저 실행이라 브리지가 없거나, Electron 이 구버전이라
 * getId 가 없거나, IPC 가 실패해도 통계 전송 자체는 계속돼야 한다.
 * 그래서 여기서 전부 삼키고 null 을 돌려준다 — MCH 의 fetchStatistics 에는 상위 try/catch 가 없다.
 */
export async function readRustDeskId(): Promise<string | null> {
    try {
        const result = await window.rustdesk?.getId?.();
        return result?.success && result.id ? result.id : null;
    } catch {
        return null;
    }
}
